.panel {
  flex: none;
  border-top: 1px solid var(--color-border);
}

.content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
